import { isNamedNode } from "rdflib";
import { vcard } from "../namespaces.js";
export class GroupQuery {
    constructor(store, groupNode) {
        this.store = store;
        this.groupNode = groupNode;
        this.groupDoc = groupNode.doc();
    }
    queryName() {
        return (this.store.anyValue(this.groupNode, vcard("fn"), undefined, this.groupDoc) ?? "");
    }
    queryMembers() {
        return this.store
            .each(this.groupNode, vcard("hasMember"), null, this.groupDoc)
            .filter((it) => isNamedNode(it))
            .map((node) => ({
            uri: node.value,
            name: this.store.anyValue(node, vcard("fn"), null, this.groupDoc) ?? "",
        }));
    }
}
//# sourceMappingURL=GroupQuery.js.map